<template>
    <div id="props">
        <div class="content">
            <div class="scrollbar left">
                <List :list="list" ref="list" :index="index"/>
            </div>
            <div class="scrollbar right">
                <div v-for="(item,i) in categoryList" :key="i" :class="{'category_type':true,'active':ct == item.category_id}" @click="changeCategoryType(item.category_id)">
                    {{ item.category_name }}
                </div>
            </div>
        </div>
        <div class="bottom">
            <el-button class="category_reset" type="info" @click="reset">重置</el-button>
            <el-button type="primary" class="category_confirm" @click="confirm">确定</el-button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            categoryList: [],
            ct: null,
            index: 0,
            list: [],
            onlyId: null
        }
    },
    mounted() {
        this.getCategory()
    },
    computed: {
        app_id() {
            return this.$store.state.gameId
        },
        category_type() {
            return this.$store.state.category_type
        }
    },
    methods: {
        getCategory() {
            var that = this
            this.$Ajax('game/app-category-list',{app_id: this.app_id}).then(rs => {
                if(rs.code == 200) {
                    this.categoryList = rs.data
                    if(this.category_type == '') {
                        this.$store.commit('setCt',rs.data[0].category_id)
                        this.ct = rs.data[0].category_id
                        this.list = this.categoryList[0].children
                    }else {
                        this.ct = this.category_type
                        rs.data.forEach((item,i) => {
                            if(item.category_id == that.ct) {
                                that.index = item.category_id
                                that.list = that.categoryList[i].children
                            }
                        })
                    }
                }
            })
        },
        changeCategoryType(category_id) {
            var that = this
            this.ct = category_id
            this.categoryList.forEach((item,i) => {
                if(item.category_id == category_id) {
                    that.index = item.category_id
                    that.list = that.categoryList[i].children
                }
            })
        },
        reset() {
            this.$refs.list.reset()
        },
        confirm() {
            this.$refs.list.confirm()
            this.$emit('handleClose')
        }
    },
}
</script>
<style lang="less" scoped>
    #props {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .content {
            flex: 1;
            display: flex;
            overflow: hidden;
            .left {
                flex: 1;
                overflow-y: auto;
                color: var(--base);
                padding: 1.5rem .9rem;
            }
            .right {
                width: 8.3rem;
                overflow-y: auto;
                background-color: #f2f2f2;
                padding: 1rem .4rem;
                .category_type {
                    height: 2.2rem;
                    line-height: 2.2rem;
                    text-align: center;
                    margin-bottom: 1rem;
                    padding: 0 0.5rem;
                    cursor: pointer;

                    &.active {
                        color: #fff;
                        background-color: var(--theme);
                        border-radius: 10rem;
                        
                    }
                }
            }
        }
        .bottom {
            width: 100%;
            height: 4.3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top: 1px solid #eee;
            /deep/.el-button {
                width: 11.5rem;
                height: 2.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 1.2rem;
                border-radius: 10rem;
                &.category_reset {
                    border-color: #999;
                    background-color: transparent;
                    color: var(--base);
                    &:active {
                        opacity: 0.8;
                        color: #fff;
                        background-color: var(--theme);
                        border-color: transparent;
                    }
                }
                &.category_confirm {
                    margin-left: 2rem;
                }
            }
        }
    }
</style>